import { TranslateService } from '@ngx-translate/core';
import { Message } from 'primeng/api';
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ValidatorService } from '@capturum/ui/api';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoginConfigService } from './login-config.service';
import { LoginConfig } from './login.config';
import { BotInfo, BrowserInfo, detect, NodeInfo, ReactNativeInfo, SearchBotDeviceInfo } from 'detect-browser';
import { take, tap } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'cap-login',
  templateUrl: 'login-layout.component.html',
  styleUrls: ['./login-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('flyDown', [
      state('in', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      transition('void => *', [
        style({
          opacity: 0,
          transform: 'translateY(-100%)'
        }),
        animate('600ms ease-in')
      ]),
      transition('* => void', [
        animate('200ms ease-out', style({
          opacity: 0,
          transform: 'translateY(-100%)'
        }))
      ]),
      transition(':leave', [
        animate('200ms ease-out', style({
          opacity: 0,
          transform: 'translateY(-100%)'
        }))
      ])
    ])
  ]
})
export class LoginLayoutComponent {
  public config$: Observable<LoginConfig>;
  public notificationSubject$: BehaviorSubject<Message> = new BehaviorSubject<Message>(null);
  private browser: BrowserInfo | SearchBotDeviceInfo | BotInfo | NodeInfo | ReactNativeInfo;

  constructor(
    private validationService: ValidatorService,
    private configService: LoginConfigService,
    private translateService: TranslateService,
  ) {
    this.translateService.setDefaultLang('nl');

    this.config$ = this.configService.getConfig().pipe(
      tap(config => {
        this.translateService.use(config.defaultLanguage);
      }),
    );

    this.validationService.setValidationMessages({
      required: 'validation-errors.required',
      password: 'validation-errors.password.general',
      equalsField: 'auth.reset-password.mismatch.message',
      email: 'validation-errors.email'
    });

    this.browser = detect();
    this.detectUnsupportedBrowser();
  }

  public hideNotification(): void {
    this.notificationSubject$.next(null);
  }

  protected detectUnsupportedBrowser(): void {
    this.config$.pipe(take(1)).subscribe(config => {
      if (this.isUnSupportedBrowser(config)) {
        this.notificationSubject$.next({
          summary: 'auth.outdated-browser.summary',
          detail: 'auth.outdated-browser.detail',
        });
      }
    });
  }

  private isUnSupportedBrowser(config: LoginConfig): boolean {
    if (!this.browser) {
      return true;
    }

    const { unsupportedBrowsers }: LoginConfig = config;
    const browserName = this.browser.name;
    const browserVersion = +this.browser.version?.split('.')?.[0];
   
    return unsupportedBrowsers.some(unsupportedBrowser => {
      return unsupportedBrowser.browser === browserName && (unsupportedBrowser.minimalVersion >= browserVersion || !unsupportedBrowser.minimalVersion);
    });
  }



}
